import React from 'react'

import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import FeaturedCategoryForPunchout from './FeaturedCategoryForPunchout'
import ShopByCategory from './ShopByCategory'

const FeaturedCategoryContainer = ({ containerObject, templateName, contentId, dataZone }) => {

    function replaceImage(event) {
		
		event.target.src = DEFAULT_IMAGE_140;

	}
    return (
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row mt-2 `} >
            
            <div className={`${containerObject.attributes.customPluginCss ? containerObject.attributes.customPluginCss : ""}`}>
            {containerObject.attributes && containerObject.attributes.customPluginTitle ? <h1 className='justify-content-center d-flex mt-5'>{containerObject.attributes.customPluginTitle}</h1> : ""}
            
            {containerObject && containerObject.results && containerObject.results.length > 0 ?
                <>
                    {containerObject && containerObject.attributes && containerObject.attributes.isHomePage && containerObject.attributes.isHomePage === "Y" ? 
                        <div className='d-flex justify-content-center d-none d-lg-block d-md-block'>
                            <FeaturedCategoryForPunchout containerObject={containerObject} />
                        </div>
                        : 
                        containerObject && containerObject.attributes && containerObject.attributes.isPageNotFoundPage && containerObject.attributes.isPageNotFoundPage === "Y" ? 
                            <ShopByCategory containerObject={containerObject}/>
                        :
                        <div className='d-flex justify-content-center'>
                            {containerObject.results.map((item) => {
                                return (<>
                                    <div className='new-text-aligin'>
                                        <Link to={item && item.productUrl ? item.productUrl : ""}>
                                            <img onError={replaceImage} alt={item && item["category.categoryName"] ? item["category.categoryName"] : ""} className='img-fluid new-shop-product-img ' src={item && item.categoryImgUrl ? item.categoryImgUrl : ""} />
                                            <p className='new-shop-product-p'>{item && item["category.categoryName"] ? item["category.categoryName"] : ""}</p>
                                        </Link>
                                    </div>
                                </>)
                            })}
                        </div>}
                    </> : ""}
                </div>
        </div>
    )
}

export default FeaturedCategoryContainer